module.exports = __webpack_public_path__ + "img/isNoPic.feaecff5.png";